"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = isShootstaEditorRoleName;
var SHOOTSTA_EDITOR_ROLE_NAME = "SHOOTSTA_EDITOR";

function isShootstaEditorRoleName(a, b) {
  return SHOOTSTA_EDITOR_ROLE_NAME === a && "ACCEPTED" === b;
}